module.exports = __webpack_public_path__ + "img/no_data.5d32f8b6.svg";